import { FC } from 'react'
import { useIntl } from 'react-intl'
import { Box, Button, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { CheckCircleOutline } from '@mui/icons-material'
import { submitButtonSx } from 'components/Helpdesk/FormPrimitives'
import theme from 'styles/theme'

const UserPersonalDataSuccess: FC = () => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        px: { xs: 2, md: 0 },
        py: { xs: 6, md: 4 },
        minHeight: { xs: '70vh', md: 'auto' },
        justifyContent: 'center'
      }}>
      <Box
        sx={{
          width: '64px',
          height: '64px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: theme.r4r.gradient,
          mb: '20px'
        }}>
        <CheckCircleOutline sx={{ color: '#fff', fontSize: '36px' }} />
      </Box>
      <Typography sx={{ fontSize: '20px', fontWeight: 700, color: theme.r4r.navy, mb: '8px' }}>
        {formatMessage({
          id: 'userDataConfirmationForm.successMessage',
          defaultMessage: 'Dziękujemy za wypełnienie formularza!'
        })}
      </Typography>
      <Typography sx={{ fontSize: '14px', color: theme.r4r.grey, mb: '28px', maxWidth: '360px' }}>
        {formatMessage({
          id: 'userDataConfirmationForm.successHint',
          defaultMessage: 'Twoje dane zostały zapisane. Możesz wrócić do panelu.'
        })}
      </Typography>
      <Button fullWidth sx={{ ...submitButtonSx, maxWidth: '360px' }} onClick={() => navigate('/')}>
        {formatMessage({
          id: 'userDataConfirmationForm.form.backToApp',
          defaultMessage: 'Wróć do aplikacji'
        })}
      </Button>
    </Box>
  )
}

export default UserPersonalDataSuccess
